export default class Protocolo {
    constructor($scope,
                $routeParams,
                method,
                protocolosService,
                tipoEquipoService,
                tipoTrabajoService,
                $filter,
                tareasService,
                $q,
                $location,
                $uibModal,
                toastr,
                proyectosService) {

        this.scope = $scope;
        this.routeParams = $routeParams;
        this.q = $q;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(protocolosService);
                break;
            case 'view':
                this.view(tareasService, protocolosService, tipoEquipoService, tipoTrabajoService,proyectosService);
                break;
            case 'new':
                this.create(tareasService, protocolosService, tipoEquipoService, tipoTrabajoService, $filter,proyectosService);
                break;
        }
    }

    list(protocolosService) {

        let self = this.scope;

        protocolosService.getAll()
            .then((resp) => {
                self.protocolos = resp.data.message;
            }).catch((err) => {
            console.log(err);
        });


        self.getItemPage = (item) => {
            let index = self.protocolos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, protocolosService);
        /*this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                protocolosService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Protocolo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al eliminar protocolo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };*/
    }

    view(tareasService, protocolosService, tipoEquipoService, tipoTrabajoService,proyectosService) {
        let id = this.routeParams.id;
        this.scope.aux = {};
        let self = this.scope;

        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: [],
        };

        this.diference = (iz, der) => {
            for (var el in der) {
                let aux = der[el];
                let index = _.findIndex(iz, (e) => {
                    return e._id == aux._id
                });
                if (index >= 0) {
                    iz.splice(index, 1);
                }
            }
            return iz;
        };

        tipoTrabajoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_trabajos = resp.data.message;
            });

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.aux.proyectos = resp.data.message;
            }
        });

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_equipos = resp.data.message;
            });

        this.scope.lista.options = {
            leftContainerLabel: 'Tareas disponibles',
            rightContainerLabel: 'Tareas Seleccionadas',
            active: true
        };

        this.q.all([
            protocolosService.getAll({_id: id})
                .then((resp) => {
                    this.scope.protocolo = resp.data.message[0];
                    this.scope.lista.derecha = resp.data.message[0].listado_tareas;
                }),
            tareasService.getAll()
                .then((resp) => {
                    let tareas = resp.data.message;
                    this.scope.lista.izquierda = tareas;
                })
        ]).then(() => {
            let iz = this.scope.lista.izquierda;
            let der = this.scope.lista.derecha;
            this.scope.lista.izquierda = this.diference(iz, der);
        });

        this.scope.inAction = false;
        this.scope.save = () => {

            if(angular.isUndefined(this.scope.protocolo.tipo_equipo) && !this.scope.protocolo.flag_preventivo) {
                this.toastr.error('Los protocolos no preventivos, requieren de un tipo de equipo.', 'Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }

            if(this.scope.protocolo.flag_preventivo && angular.isDefined(this.scope.protocolo.tipo_equipo)){
                if(!self.esRequeridoTipoEquipo()) {
                    this.scope.protocolo.tipo_equipo = null;
                }
            }


            if (!this.scope.inAction && this.scope.lista.derecha.length > 0) {
                this.scope.inAction = true;
                let protocolo = this.scope.protocolo;
                protocolo.listado_tareas = this.scope.lista.derecha;
                protocolosService.update(protocolo)
                    .then((resp) => {
                        this.toastr.success('Protocolo modificado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/protocolos');
                    }).catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar protocolo!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }   else {
                this.toastr.error('Debe seleccionar al menos una tarea.', 'Error', {
                    timeOut: 2000,
                    closeButton: true
                });
            }
        };

        this.scope.esRequeridoTipoEquipo = () => {
            let self = this;
            let result = true;
            
            if(typeof this.scope.protocolo !== 'undefined' && this.scope.protocolo != null) {
                let proyecto = this.scope.protocolo.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos.protocolos !== "undefined" && proyecto.no_requeridos.protocolos != null) {
                            if (typeof proyecto.no_requeridos.protocolos.preventivo !== "undefined" && proyecto.no_requeridos.protocolos.preventivo != null) {
                                result = proyecto.no_requeridos.protocolos.preventivo.indexOf('tipo_equipo') > -1;
                                if(result) {
                                    result = !self.scope.protocolo.flag_preventivo;
                                }
                            }
                        }
                    }
                }
            } 

            if(!result) {
                this.scope.protocolo.tipo_equipo = null;
            }
            return result;
        }

    }

    create(tareasService, protocolosService, tipoEquipoService, tipoTrabajoService, $filter,proyectosService) {
        this.scope.protocolo = {};
        this.scope.aux = {};
        var self = this.scope;

        this.scope.full = {
            izquierda: [],
            derecha: []
        };

        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: [],
            options: {
                leftContainerLabel: 'Tareas disponibles',
                rightContainerLabel: 'Tareas Seleccionadas',
                active: true,
                leftContainerSearch: function (text) {
                    self.lista.izquierda = $filter('filter')(self.full.izquierda, {
                        'nombre': text
                    });
                },
                rightContainerSearch: function (text) {
                    self.lista.derecha = $filter('filter')(self.full.derecha, {
                        'nombre': text
                    });
                }
            }
        };

        tareasService.getAll()
            .then((resp) => {
                let tareas = resp.data.message;
                this.scope.lista.izquierda = tareas;
                this.scope.full.izquierda = angular.copy(tareas);
            });

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_equipos = resp.data.message;
            });

        tipoTrabajoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_trabajos = resp.data.message;
            });

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.aux.proyectos = resp.data.message;
            }
        });

        this.scope.inAction = false;
        this.scope.save = () => {

            if(angular.isUndefined(this.scope.protocolo.tipo_equipo) && !this.scope.protocolo.flag_preventivo) {
                this.toastr.error('Los protocolos no preventivos, requieren de un tipo de equipo.', 'Error', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }

            if(this.scope.protocolo.flag_preventivo && angular.isDefined(this.scope.protocolo.tipo_equipo)){
                if(self.esRequeridoTipoEquipo()) {
                    this.scope.protocolo.tipo_equipo = null;
                }
            }

            if (!this.scope.inAction && this.scope.lista.derecha.length > 0) {

                this.scope.inAction = true;
                let protocolo = this.scope.protocolo;
                protocolo.listado_tareas = this.scope.lista.derecha;
                protocolo.flag_preventivo = this.scope.protocolo.flag_preventivo ? this.scope.protocolo.flag_preventivo : false;
                protocolosService.save(protocolo)
                    .then((resp) => {
                        this.toastr.success('Protocolo creado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/protocolos');
                    }).catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear protocolo!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            } else {
                this.toastr.error('Debe seleccionar al menos una tarea.', 'Error', {
                    timeOut: 2000,
                    closeButton: true
                });
            }
        };

        this.scope.esRequeridoTipoEquipo = () => {
            let self = this;
            let result = true;
            
            if(typeof this.scope.protocolo !== 'undefined' && this.scope.protocolo != null) {
                let proyecto = this.scope.protocolo.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos.protocolos !== "undefined" && proyecto.no_requeridos.protocolos != null) {
                            if (typeof proyecto.no_requeridos.protocolos.preventivo !== "undefined" && proyecto.no_requeridos.protocolos.preventivo != null) {
                                result = proyecto.no_requeridos.protocolos.preventivo.indexOf('tipo_equipo') > -1;
                                if(result) {
                                    result = !self.scope.protocolo.flag_preventivo;
                                }
                            }
                        }
                    }
                }
            } 

            if(!result) {
                this.scope.protocolo.tipo_equipo = null;
            }
            return result;
        }


    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Protocolo</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el protocolo: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.protocolos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Protocolo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el protocolo!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/protocolos/protocolos.js